import React from 'react';

const Footer = () => {
  return (
    <footer className="relative border-t border-white/10 bg-[#0a0a0a]">
      <div className="px-6 md:px-12 lg:px-20 py-8">
        <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
          <p className="text-sm text-white/40">Batman App</p>
          <p className="text-sm text-white/40">© 2026 NeoPass. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
